import React from 'react'
import styled from 'styled-components';
import { Button } from '../../elements/Button';

const WhatsupMessageBox = () => {
    const Wrapper = styled.section`
    padding: 0rem 0 5rem 0;
    .container {
      margin-top: 6rem;
      text-align: center;
      .contact-form {
        max-width: 50rem;
        margin: auto;
        .contact-inputs {
          display: flex;
          flex-direction: column;
          gap: 3rem;
          input[type="submit"] {
            
            font-size: 2.5rem;
            max-width: none;
            margin: 0 2rem;
            cursor: pointer;
            transition: all 0.2s;
            &:hover {
              background-color: ${({ theme }) => theme.colors.white};
              border: 1px solid ${({ theme }) => theme.colors.btn};
              color: ${({ theme }) => theme.colors.btn};
              transform: scale(0.9);
            }
          }
        }
      }
    }
  `;

  function GoToWhatsupPage(){
    var name = document.getElementById("name").value;
    var phone = document.getElementById("ContactNumber").value;
    var Message = document.getElementById("Message").value;

    var url = "https://wa.me/919982852960?text="
        + "Name: " + name + "%0a"
        + "Phone: " + phone + "%0a"
        + "Message: " + Message;

    window.open(url, '_blank').focus();
};
  

  return (
    <Wrapper>

      <div className="container">
        <div className="contact-form">
          <form
            autoComplete='off'
            className="contact-inputs"
          >
            <input
              type="text"
              name="username"
              id="name"
              placeholder="username"
              autoComplete="off"
              required
            />

            <input
              type="number"
              name="ContactNumber"
              id="ContactNumber"
              placeholder="Contact Number"
              autoComplete="off"
              required
            />

            <textarea
              name="message"
              cols="30"
              rows="6"
              id='Message'
              placeholder="Type your question"
              autoComplete="off"
              required
            ></textarea>
            
            <input  type="submit" value="send message on whatsapp" onClick={GoToWhatsupPage} />
            
          </form>
        </div>
      </div>
    </Wrapper>
  );
};



export default WhatsupMessageBox;
